import { memo, useState } from 'react'
import {
  FormControlLabel,
  Radio as RadioMui,
  RadioGroup as RadioGroupMui,
  SxProps,
  FormControl,
  FormLabel,
} from '@mui/material'
import { randomString } from '@/utils'
import { Text } from '@/components/Data'

import { RadioCheckedIcon, RadioIcon } from './RadioIcon'
import { RadioGroupProps, RadioInputProps, RadioProps } from './Radio.types'
import { radioStyles as styles } from './Radio.style'

function RadioInput({ ...props }: RadioInputProps) {
  return (
    <RadioMui
      disableRipple
      color="default"
      checkedIcon={<RadioCheckedIcon />}
      icon={<RadioIcon />}
      {...props}
    />
  )
}

function Radio({
  label,
  labelProps = {},
  radioInputProps = {},
  slotProps = {},
  sx = {},
  ...props
}: RadioProps) {
  const { sx: labelSx = {}, ...otherLabelProps } = labelProps
  const { typography = {}, ...otherSlotProps } = slotProps
  return (
    <FormControlLabel
      sx={[styles.formControlLabel, sx] as SxProps}
      label={
        typeof label === 'string' ? (
          <Text
            sx={[styles.radioLabel, labelSx] as SxProps}
            variant="textSmMedium"
            {...otherLabelProps}>
            {label}
          </Text>
        ) : (
          label
        )
      }
      control={<RadioInput {...radioInputProps} />}
      slotProps={{
        typography: { sx: styles.radioLabelWrapper, ...typography },
        ...otherSlotProps,
      }}
      {...props}
    />
  )
}

function RadioGroup({ title, titleProps = {}, ...props }: RadioGroupProps) {
  const [groupId] = useState(`radio-group-${randomString(5)}`)

  const { sx: titleSx = {}, ...otherTitleProps } = titleProps
  return (
    <FormControl className="w-100">
      {title && (
        <FormLabel id={groupId}>
          <Text
            sx={[styles.radioGroupTitle, titleSx] as SxProps}
            variant="textMdSemibold"
            {...otherTitleProps}>
            {title}
          </Text>
        </FormLabel>
      )}
      <RadioGroupMui aria-labelledby={groupId} {...props} />
    </FormControl>
  )
}

const MemoRadioInput = memo(RadioInput)
const MemoRadioGroup = memo(RadioGroup)
export { MemoRadioInput as RadioInput, MemoRadioGroup as RadioGroup }
export default memo(Radio)
